module.exports = __webpack_public_path__ + "ma.svg?821b32398c1b5dbe1834770ef5f6ba61";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ma.svg
// module id = 1227
// module chunks = 0